import http from './http';

const BASE = '/admin/integrations/google-drive';

export interface GoogleDriveStatus {
    /** False when the user's role can't use Drive export (non-admin, impersonating). */
    available: boolean;
    /** False when the server has no Drive OAuth client / encryption key. */
    configured: boolean;
    connected: boolean;
    googleAccountEmail?: string;
}

export async function fetchGoogleDriveStatus(): Promise<GoogleDriveStatus> {
    const response = await http.get(`${BASE}/status`);
    return response.data;
}

/** Google consent URL; the callback sends the browser back to `returnPath` with `?googleDrive=…`. */
export async function fetchGoogleDriveOAuthUrl(returnPath: string): Promise<string> {
    const response = await http.post(`${BASE}/oauth-url`, { returnPath });
    return response.data.url;
}

export async function disconnectGoogleDrive(): Promise<void> {
    await http.post(`${BASE}/disconnect`, {});
}

/** Builds the document server-side, uploads it to the user's Drive, and returns the Google Doc URL. */
export async function exportArtifactToGoogleDrive(payload: {
    markdownBody: string;
    documentTitle: string;
    isStandalone?: boolean;
    platformContext?: 'aria_chat' | 'aptive_index' | 'both';
}): Promise<string> {
    // DOCX build + Drive conversion can exceed the 30s default; timing out early would orphan the Doc
    const response = await http.post(`${BASE}/export`, payload, { timeout: 120000 });
    return response.data.url;
}
